const faqs = [
  {
    id: 1,
    heading: 'What to do in a lockout situation?',
    content: 'Discover the steps to take when facing a lockout situation. Learn how our locksmith services can quickly assist you in regaining access to your property or vehicle.',
  },
  {
    id: 2,
    heading: 'How can I get a replacement key?',
    content: 'Explore the process of obtaining a replacement key for your home, office, or vehicle. Our locksmiths offer key cutting and duplication services to ensure you always have a spare.',
  },
  {
    id: 3,
    heading: 'Can you repair damaged locks?',
    content: 'Learn about our lock repair services for fixing damaged or malfunctioning locks. Our skilled locksmiths can assess the issue and provide effective repair solutions to enhance security.',
  },
  {
    id: 4,
    heading: 'Do you offer security upgrade options?',
    content: 'Discover our range of security upgrade options to enhance the protection of your property. From high-security locks to smart security systems, we can recommend and install the right solutions for your needs.',
  },
  {
    id: 5,
    heading: 'How quickly can you respond to emergencies?',
    content: 'Find out about our rapid response times for emergency locksmith services. We prioritize urgent calls and strive to reach your location promptly to address your locksmith needs.',
  },
];

export default faqs;